import * as React from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';

import { PendingReservations } from './components/pending-reservations';
import { AllReservations } from './components/all-reservations';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`manager-reservations-tabpanel-${index}`}
      aria-labelledby={`manager-reservations-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export function CommunityReservationsPage(): React.JSX.Element {
  const [currentTab, setCurrentTab] = React.useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Paper
      elevation={0}
      sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: { xs: 2, md: 3 } }}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="manager reservations tabs">
          <Tab label="Pending Approvals" id="manager-reservations-tab-0" />
          <Tab label="All Reservations" id="manager-reservations-tab-1" />
        </Tabs>
      </Box>

      <Box sx={{ px: { xs: 2, md: 3 }, pb: 3 }}>
        <TabPanel value={currentTab} index={0}>
          <PendingReservations />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <AllReservations />
        </TabPanel>
      </Box>
    </Paper>
  );
}





